/* ============================================================================
   PACK UPSELL — "one more and the price drops", in the bag.

   Mounted by snippets/umai-pack-upsell.liquid on the cart page and inside the
   cart drawer. Reads /cart.js, counts how many of the pack-priced product are
   already in the bag, and offers the shortest hop to the next tier.

   The button re-adds the variant ALREADY IN THE BAG. That is the entire point:
   the shopper picked a colour and a size on the PDP, and asking them to pick
   again in the cart is where these upsells normally die. If their exact variant
   has sold out since, it falls back to another available size in the same
   colour, then to any available variant, and only gives up if the product is
   genuinely gone.

   ⚠ Tier prices come from the snippet's config and must match the PDP ladder
   AND the Shopify automatic discounts. The bag must never promise a total the
   checkout will not honour.
   ========================================================================== */
(function () {
  'use strict';

  var I18N = window.UMAI_I18N || {};
  function tr(k, fb) { return I18N[k] || fb; }
  function trf(k, fb, vars) {
    var s = tr(k, fb);
    for (var p in vars) s = s.split('[' + p + ']').join(vars[p]);
    return s;
  }
  /* 2026-09-07 (Ryan) — the same four-line escaper assets/umai-bundle.js has
     carried since it was written; this file never had one. Every card below is
     built by gluing merchant-controlled text (the Core Tee's title, its colour
     names, its size labels, the image URLs) straight into innerHTML. Nothing is
     broken today — those strings are all plain words — but a colour renamed
     with a straight double quote would break data-c="…", so the picker would
     stop matching and the pack add would silently fail on a revenue surface,
     and a "<" would inject markup into every cart drawer on the store. Only
     staff or an installed app can set that text, so this is a guard, not a fix
     for a live bug. Keep it. */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency) || {};
    var rate = parseFloat(cur.rate) || 1;
    var v = cents * rate;
    if (cur.active && cur.active !== 'USD') {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur.active }).format(v / 100); } catch (e) {}
    }
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    return fmt.replace(/<[^>]+>/g, '').replace(/\{\{\s*amount[^}]*\}\}/, (v / 100).toFixed(2)).trim();
  }

  /* 2026-09-07 (Ryan) — the dataLayer and fbq lines here have never reached
     GA4 or Meta. Both run on this store as Shopify Customer Events pixels,
     inside a sandboxed frame that cannot see this page's window.dataLayer or
     window.fbq (the served HTML contains no googletagmanager, no gtag and no
     connect.facebook.net). Only Klaviyo's _learnq shim was ever real.
     Shopify.analytics.publish is the one bridge from theme code into that
     sandbox. The two dead lines stay — they cost nothing and start working the
     day a GTM container or a real Meta pixel is added to the page directly.
     ⚠ HALF OF THIS FIX IS IN ADMIN: publish() is a no-op until a Custom Pixel
     (Settings -> Customer events) subscribes to these umai_upsell_* names and
     forwards them on. Until then the upsell data still goes nowhere. */
  function track(name, data) {
    var ev = 'umai_upsell_' + name, payload = data || {};
    try {
      window.dataLayer = window.dataLayer || [];
      var row = { event: ev };
      for (var k in payload) row[k] = payload[k];
      window.dataLayer.push(row);
    } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', ev, payload); } catch (e) {}
    try { if (window._learnq) window._learnq.push(['track', ev, payload]); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(ev, payload);
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent(ev, { detail: payload })); } catch (e) {}
  }

  function init(root) {
    var cfgEl = root.querySelector('[data-uups-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!cfg.tiers || !cfg.tiers.length || !cfg.variants) return;

    var byId = {};
    cfg.variants.forEach(function (v) { byId[v.id] = v; });
    var lastSig = null, adding = false;

    /* variant titles are "Colour / Size" */
    function colourOf(t) { return String(t || '').split(' / ')[0]; }
    function sizeOf(t) { var p = String(t || '').split(' / '); return p.length > 1 ? p[1] : ''; }

    /* Shopify gives a colour NAME and no swatch, so match on the words apparel
       colour names are built from, longest match wins. Unmatched falls back to
       a neutral chip — visibly a placeholder, never a confidently wrong colour. */
    var SWATCH = [['heather','#A8A5A0'],['charcoal','#3A3A3C'],['black','#15120F'],
      ['white','#F7F6F3'],['cream','#EFE7D8'],['bone','#E8E3D8'],['sand','#D9C9AE'],
      ['navy','#1B2A44'],['blue','#2E5C9A'],['olive','#5E6642'],['green','#2F6B45'],
      ['red','#B32118'],['pink','#E2A0B4'],['brown','#6B4A32'],['grey','#9C9A95'],['gray','#9C9A95']];
    function swatchFor(name) {
      var n = String(name || '').toLowerCase(), best = null, len = 0;
      for (var i = 0; i < SWATCH.length; i++) {
        if (n.indexOf(SWATCH[i][0]) > -1 && SWATCH[i][0].length > len) { best = SWATCH[i][1]; len = SWATCH[i][0].length; }
      }
      return best || '#CFCBC4';
    }

    /* ---- the picker ----
       The cross-sell has no size to re-use, so rather than bouncing the shopper
       to the product page and out of the bag, it opens a small chooser here.
       Appended to <body>, never inside the drawer: theme.css:517 sets
       `main{overflow:hidden}`, which clips fixed-position descendants — the
       same trap that ate the pack picker overlay in August. */
    var ov = null, pickC = null, pickS = null;

    function closePicker() {
      if (!ov) return;
      ov.classList.remove('on');
      document.body.style.overflow = '';
    }

    function openPicker(tier) {
      var colours = [], sizes = [];
      cfg.variants.forEach(function (v) {
        var c = colourOf(v.t), z = sizeOf(v.t);
        if (c && colours.indexOf(c) < 0) colours.push(c);
        if (z && sizes.indexOf(z) < 0) sizes.push(z);
      });
      function variantFor(c, z) {
        for (var i = 0; i < cfg.variants.length; i++) {
          if (colourOf(cfg.variants[i].t) === c && sizeOf(cfg.variants[i].t) === z) return cfg.variants[i];
        }
        return null;
      }
      function inStock(c, z) { var v = variantFor(c, z); return !!(v && v.a); }

      if (!ov) {
        ov = document.createElement('div');
        ov.className = 'uups-ov';
        document.body.appendChild(ov);
        ov.addEventListener('click', function (e) {
          if (e.target === ov || e.target.closest('[data-uups-x]')) closePicker();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && ov && ov.classList.contains('on')) closePicker();
        });
      }
      if (!pickC || colours.indexOf(pickC) < 0) pickC = colours[0];
      pickS = null;

      function paint() {
        var v = (pickC && pickS) ? variantFor(pickC, pickS) : null;
        var per = Math.floor(tier.price / tier.qty);
        var cHtml = colours.map(function (c) {
          var dead = !sizes.some(function (z) { return inStock(c, z); });
          return '<button type="button" class="uups-c' + (dead ? ' oos' : '') + '" data-c="' + esc(c) + '"'
               + ' aria-pressed="' + (c === pickC) + '"' + (dead ? ' disabled' : '')
               + ' style="--c:' + swatchFor(c) + '"><i></i><span>' + esc(c) + '</span></button>';
        }).join('');
        var zHtml = sizes.map(function (z) {
          var ok = inStock(pickC, z);
          return '<button type="button" class="uups-z' + (ok ? '' : ' oos') + '" data-z="' + esc(z) + '"'
               + ' aria-pressed="' + (z === pickS) + '"' + (ok ? '' : ' disabled') + '>' + esc(z) + '</button>';
        }).join('');
        ov.innerHTML =
          /* 2026-09-07 (Ryan) — these two were the last English literals in this
             dialog; everything around them already went through tr(). They are
             screen-reader-only, so nobody reported them. pack_close was already
             bridged; upsell_mod_aria is new (umai.upsell.mod_aria). */
          '<div class="uups-mod" role="dialog" aria-modal="true" aria-label="' + esc(tr('upsell_mod_aria', 'Choose your pack')) + '">'
          + '<button class="uups-x" type="button" data-uups-x aria-label="' + esc(tr('pack_close', 'Close')) + '">&#10005;</button>'
          + '<div class="uups-mh">' + trf('upsell_mod_h', '[n] blanks for [total]', { n: tier.qty, total: money(tier.price) }) + '</div>'
          + '<div class="uups-ms">' + trf('upsell_mod_s', '[amount] a shirt. All [n] the same colour and size.', { amount: money(per), n: tier.qty }) + '</div>'
          + '<div class="uups-lbl">' + tr('opt_color', 'Colour') + '</div>'
          + '<div class="uups-row">' + cHtml + '</div>'
          + '<div class="uups-lbl">' + tr('opt_size', 'Size') + '</div>'
          + '<div class="uups-row">' + zHtml + '</div>'
          + '<button type="button" class="uups-go" data-uups-go' + (v ? '' : ' disabled') + '>'
          + (v ? trf('upsell_mod_cta', 'Add [n] to bag - [total]', { n: tier.qty, total: money(tier.price) })
               : tr('upsell_mod_pick', 'Choose a size'))
          + '</button>'
          + '<div class="uups-note" data-uups-note hidden></div>'
          + '</div>';
        ov.querySelectorAll('[data-c]').forEach(function (b) {
          b.addEventListener('click', function () {
            pickC = b.dataset.c;
            if (pickS && !inStock(pickC, pickS)) pickS = null;   /* their size may not exist in the new colour */
            paint();
          });
        });
        ov.querySelectorAll('[data-z]').forEach(function (b) {
          b.addEventListener('click', function () { pickS = b.dataset.z; paint(); });
        });
        var go = ov.querySelector('[data-uups-go]');
        if (v) go.addEventListener('click', function () { add(v, tier.qty, tier, go); });
      }

      paint();
      ov.classList.add('on');
      document.body.style.overflow = 'hidden';
      track('picker_open', { tier: tier.qty, where: root.dataset.where });
    }

    /* Which variant should "add one more" add? Their own first. If that has
       gone out of stock, the same colour in any size, then anything available. */
    function pickVariant(preferredId) {
      var mine = byId[preferredId];
      if (mine && mine.a) return mine;
      var i, c = mine ? colourOf(mine.t) : null;
      if (c) for (i = 0; i < cfg.variants.length; i++) {
        if (cfg.variants[i].a && colourOf(cfg.variants[i].t) === c) return cfg.variants[i];
      }
      for (i = 0; i < cfg.variants.length; i++) if (cfg.variants[i].a) return cfg.variants[i];
      return null;
    }

    /* ---- THE PACK CARD (cross-sell) ----
       Shaped after True Classic's bag upsell: a collage of the actual
       colourways, the pack name, what is in it, the price against the struck
       single-shirt total, a savings badge, and ONE wide button.

       "Add all 3" means one of EACH colour, not three of the same. That is the
       offer people actually want from a blanks pack, it shows off the range,
       and it still trips the 3-item discount because the tier is a quantity
       rule on the product rather than on a variant.

       Size is the one thing it cannot guess, so it defaults to the middle of
       the run and stays changeable in one tap — the button never sits dead. */
    var packSize = null;

    function renderPackCard(tier, otherTees) {
      var colours = (cfg.colours || []).filter(function (c) {
        return cfg.variants.some(function (v) { return colourOf(v.t) === c.name && v.a; });
      });
      if (colours.length < 2) { root.hidden = true; return; }

      var sizes = [];
      cfg.variants.forEach(function (v) {
        var z = sizeOf(v.t);
        if (z && sizes.indexOf(z) < 0) sizes.push(z);
      });
      /* default to the middle of the size run — closer to most people than S,
         and it means the CTA is live the moment the card appears */
      if (!packSize || sizes.indexOf(packSize) < 0) packSize = sizes[Math.floor(sizes.length / 2)] || sizes[0];

      function variantFor(c, z) {
        for (var i = 0; i < cfg.variants.length; i++) {
          if (colourOf(cfg.variants[i].t) === c && sizeOf(cfg.variants[i].t) === z) return cfg.variants[i];
        }
        return null;
      }
      function sizeOK(z) {
        /* only offer a size the whole pack can actually be built in */
        return colours.slice(0, tier.qty).every(function (c) { var v = variantFor(c.name, z); return v && v.a; });
      }
      if (!sizeOK(packSize)) { for (var i = 0; i < sizes.length; i++) if (sizeOK(sizes[i])) { packSize = sizes[i]; break; } }

      var pick = colours.slice(0, tier.qty);
      var was = cfg.unit * tier.qty;
      var save = was - tier.price;
      var hero = pick[0], rest = pick.slice(1, 3);

      root.innerHTML =
        '<div class="uups-card">' +
          '<div class="uups-top">' +
            '<div class="uups-shots">' +
              '<div class="uups-big">' +
                /* NOT lazy: these sit inside a closed drawer, where the lazy
                   heuristic defers them and does not reliably re-fire when the
                   panel opens — the card then shows three empty boxes at the
                   exact moment someone is looking at it. 19-37KB each. */
                (hero.img ? '<img src="' + esc(hero.img) + '" alt="' + esc(hero.name) + '" decoding="async">' : '') +
                '<span class="uups-tag">' + trf('upsell_npack', '[n]-Pack', { n: tier.qty }) + '</span>' +
              '</div>' +
              (rest.length ? '<div class="uups-side">' + rest.map(function (c) {
                return '<div class="uups-sm">' + (c.img ? '<img src="' + esc(c.img) + '" alt="' + esc(c.name) + '" decoding="async">' : '') + '</div>';
              }).join('') + '</div>' : '') +
            '</div>' +
            '<div class="uups-info">' +
              '<div class="uups-name">' + esc(cfg.title) + ' ' + trf('upsell_npack', '[n]-Pack', { n: tier.qty }) + '</div>' +
              '<div class="uups-vars">' + pick.map(function (c) { return esc(c.name); }).join(' &middot; ') + '</div>' +
              '<div class="uups-price"><b>' + money(tier.price) + '</b><s>' + money(was) + '</s></div>' +
              (save > 0 ? '<span class="uups-save">' + trf('upsell_save', 'Save [amount]', { amount: money(save) }) + '</span>' : '') +
            '</div>' +
          '</div>' +
          '<div class="uups-sizes">' +
            '<span class="uups-szl">' + tr('opt_size', 'Size') + '</span>' +
            sizes.map(function (z) {
              var ok = sizeOK(z);
              return '<button type="button" class="uups-z' + (ok ? '' : ' oos') + '" data-z="' + esc(z) + '"' +
                ' aria-pressed="' + (z === packSize) + '"' + (ok ? '' : ' disabled') + '>' + esc(z) + '</button>';
            }).join('') +
          '</div>' +
          '<button type="button" class="uups-all" data-uups-all>' +
            trf('upsell_add_all', 'Add all [n]', { n: tier.qty }) + ' <span aria-hidden="true">&rarr;</span>' +
          '</button>' +
          '<div class="uups-note" data-uups-note hidden></div>' +
        '</div>';

      root.hidden = false;
      /* ⚠ Do NOT re-render the card here. Rebuilding innerHTML on click detaches
         the button mid-event, so by the time the drawer's own document-level
         "did they click outside the panel?" handler runs, e.target has no
         ancestors — closest() returns null, the click reads as outside, and the
         drawer shuts on you. Nothing about the card depends on which size is
         selected except the pressed state, so flip that in place and stop the
         event here for good measure. */
      root.querySelectorAll('[data-z]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (b.disabled) return;
          packSize = b.dataset.z;
          root.querySelectorAll('[data-z]').forEach(function (o) {
            o.setAttribute('aria-pressed', String(o === b));
          });
        });
      });
      root.querySelector('[data-uups-all]').addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();   /* same reason as the size buttons above */
        addPack(pick, packSize, tier, e.currentTarget, variantFor);
      });

      if (lastSig !== 'pack') {
        lastSig = 'pack';
        track('view', { kind: 'crosssell', tier: tier.qty, other_tees: otherTees, where: root.dataset.where });
      }
    }

    /* one line per colour, one request */
    function addPack(pick, size, tier, btn, variantFor) {
      if (adding) return;
      var items = [];
      for (var i = 0; i < pick.length; i++) {
        var v = variantFor(pick[i].name, size);
        if (!v || !v.a) { showNote(tr('upsell_gone', 'That size just sold out in one of the colours.')); return; }
        items.push({ id: v.id, quantity: 1 });
      }
      adding = true;
      var label = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = tr('pdp_adding', 'Adding…');
      track('add_all', { tier: tier.qty, size: size, where: root.dataset.where, value: tier.price / 100 });

      fetch(((window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.text().then(function (tx) {
          var m = ''; try { var j = JSON.parse(tx); m = (j && typeof j.description === 'string') ? j.description : ''; } catch (e) {}
          throw new Error(m || tr('pdp_add_error', 'Could not add to bag — please try again.'));
        }, function () { throw new Error(tr('pdp_add_error', 'Could not add to bag — please try again.')); });
        adding = false;
        if (root.dataset.where === 'cart') { window.location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        refresh();
      }).catch(function (err) {
        adding = false;
        btn.disabled = false; btn.innerHTML = label;
        showNote((err && err.message) || tr('pdp_add_error', 'Could not add to bag — please try again.'));
      });
    }

    function showNote(msg) {
      var n = root.querySelector('[data-uups-note]');
      if (n) { n.textContent = msg; n.hidden = false; }
    }

    function render(cart) {
      var lines = (cart && cart.items || []).filter(function (it) { return it.handle === cfg.handle; });
      var have = lines.reduce(function (a, i) { return a + i.quantity; }, 0);

      /* ---- the cross-sell ----
         No blanks in the bag, but they ARE buying t-shirts: pitch the blanks.
         Someone with a graphic tee in the bag has already decided they want a
         t-shirt from us, which is the only qualification that matters here.
         A bag with no tees at all (a hoodie, a poster) gets nothing — an
         unrelated product card in the bag is just noise.

         This state LINKS to the product page rather than adding: there is no
         size to reuse, and making someone pick a colour and a size inside the
         bag is how you lose them. The one-tap add is only for people who
         already told us their size. */
      var otherTees = (cart && cart.items || []).filter(function (it) {
        return it.handle !== cfg.handle && /t-?shirt/i.test(it.product_title || it.title || '');
      }).reduce(function (a, i) { return a + i.quantity; }, 0);

      if (!have && !otherTees) { root.hidden = true; return; }

      if (!have) {
        renderPackCard(cfg.tiers[0], otherTees);
        return;
      }

      /* The DEEPEST tier they have already earned, and the next one up. */
      var next = null, reached = null;
      for (var i = 0; i < cfg.tiers.length; i++) {
        if (have >= cfg.tiers[i].qty) reached = cfg.tiers[i];
        else if (!next) next = cfg.tiers[i];
      }

      /* ---- the confirmation ----
         Shopify allocates a pack discount across the individual lines, so a
         $59.99 three-pack shows up as $20.00 / $20.00 / $19.99 with nothing
         anywhere naming the pack. The saving is real and visible in the
         subtotal, but the shopper has to do the arithmetic to believe it.
         State it. */
      var applied = reached
        ? '<div class="uups-ok">' +
            '<span class="uups-tick" aria-hidden="true">&#10003;</span>' +
            trf('upsell_applied', '[n]-Pack applied &mdash; [amount] a shirt',
                { n: reached.qty, amount: money(Math.floor(reached.price / reached.qty)) }) +
            '<b>' + trf('upsell_saved', 'You saved [amount]',
                { amount: money((cfg.unit * reached.qty) - reached.price) }) + '</b>' +
          '</div>'
        : '';

      /* ---- once a pack is earned, stop selling ----
         Reaching a tier ends the pitch. Following "3-Pack applied" with "add 3
         more" turns a moment of "good, that worked" into another ask, and it
         is the same ask they just answered. Show the confirmation alone; the
         6-pack is still on the product page for anyone who wants it. */
      if (reached) {
        root.innerHTML = applied;
        root.hidden = !applied;
        var doneSig = 'done:' + reached.qty;
        if (lastSig !== doneSig) { lastSig = doneSig; track('applied', { tier: reached.qty, where: root.dataset.where }); }
        return;
      }
      if (!next) { root.hidden = true; return; }

      var need = next.qty - have;
      var per = Math.floor(next.price / next.qty);     /* floor: never overstate */
      var save = (cfg.unit * next.qty) - next.price;
      /* what this click actually costs them, not the pack total */
      var addCost = next.price - (cfg.unit * have);

      /* which variant they'd be adding, and its picture */
      var src = lines[lines.length - 1];
      var v = pickVariant(src && src.id);
      if (!v) { root.hidden = true; return; }
      var img = (src && (src.image || (src.featured_image && src.featured_image.url))) || cfg.img;
      if (img) img = String(img).split('?')[0] + '?width=200';

      root.innerHTML =
        '<div class="uups-in">' +
          (img ? '<img class="uups-img" src="' + esc(img) + '" alt="" width="64" height="80" loading="lazy">' : '') +
          '<div class="uups-tx">' +
            '<div class="uups-h">' +
              trf(need === 1 ? 'upsell_one' : 'upsell_many',
                  need === 1 ? 'Add 1 more, pay [amount] a shirt' : 'Add [n] more, pay [amount] a shirt',
                  { n: need, amount: money(per) }) +
            '</div>' +
            '<div class="uups-s">' +
              trf('upsell_sub', '[n]-Pack &mdash; [total] for all [n]. You save [save].',
                  { n: next.qty, total: money(next.price), save: money(save) }) +
            '</div>' +
          '</div>' +
          '<button type="button" class="uups-btn" data-uups-add>' +
            trf('upsell_cta', 'Add [n] &middot; [amount]', { n: need, amount: money(addCost > 0 ? addCost : cfg.unit * need) }) +
          '</button>' +
        '</div>' +
        '<div class="uups-note" data-uups-note hidden></div>';

      root.hidden = false;
      root.querySelector('[data-uups-add]').addEventListener('click', function () { add(v, need, next); });

      var sig = have + ':' + next.qty;
      if (sig !== lastSig) {
        lastSig = sig;
        track('view', { have: have, tier: next.qty, need: need, where: root.dataset.where });
      }
    }

    function add(v, need, tier, btnOverride) {
      if (adding) return;
      adding = true;
      var btn = btnOverride || root.querySelector('[data-uups-add]');
      var label = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = tr('pdp_adding', 'Adding…');
      track('click', { variant: v.id, qty: need, tier: tier.qty, where: root.dataset.where });

      fetch(((window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: need }] })
      }).then(function (r) {
        if (!r.ok) return r.text().then(function (tx) {
          var m = ''; try { var j = JSON.parse(tx); m = (j && typeof j.description === 'string') ? j.description : ''; } catch (e) {}
          throw new Error(m || tr('pdp_add_error', 'Could not add to bag — please try again.'));
        }, function () { throw new Error(tr('pdp_add_error', 'Could not add to bag — please try again.')); });
        track('added', { variant: v.id, qty: need, tier: tier.qty, value: tier.price / 100, where: root.dataset.where });
        adding = false;
        closePicker();
        /* The cart page is server-rendered — line items, totals and the reward
           bars all come from Liquid, so a reload is the only honest way to show
           the new state. The drawer re-renders itself off cart:updated. */
        if (root.dataset.where === 'cart') { window.location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        refresh();
      }).catch(function (err) {
        adding = false;
        btn.disabled = false; btn.innerHTML = label;
        var n = (ov && ov.classList.contains('on') && ov.querySelector('[data-uups-note]')) || root.querySelector('[data-uups-note]');
        if (n) { n.textContent = (err && err.message) || tr('pdp_add_error', 'Could not add to bag — please try again.'); n.hidden = false; }
      });
    }

    /* 2026-09-07 (Ryan) — takes the OPTIONAL event, so a cart:updated that
       carries the cart (snippets/cart-drawer.liquid now dispatches
       `new CustomEvent('cart:updated', { detail: cart })`) is answered from that
       payload instead of fetching the same 300-byte /cart.js the drawer fetched
       a millisecond earlier. Same change assets/umai-pdp.js updateB2G got.
       Before this, one product-page load ran five to eight reads of one file and
       every add-to-cart ran five, because the drawer announced the change and
       three listeners each went and refetched it.
       It STILL fetches when there is no detail — cart:refresh carries none, this
       file's own post-add dispatch carries none, and a shopper on a cached older
       drawer sends a bare event — so it is correct whether or not the drawer half
       is deployed. Do not "simplify" it to detail-only. */
    function refresh(e) {
      var d = e && e.detail;
      if (d && Array.isArray(d.items)) { render(d); return; }
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () { root.hidden = true; });
    }

    /* The initial read stays a fetch. This card also mounts on the cart page,
       where no drawer ever fires a first cart:updated, and the script is
       deferred — waiting for someone else's event would leave the bag's upsell
       blank. One request per page, not per event. */
    refresh();
    var t = null;
    ['cart:updated', 'cart:refresh'].forEach(function (ev) {
      /* the 250 ms debounce stays (one add fires several of these); it just
         carries the freshest event through, so the coalesced run can use its
         cart instead of asking again */
      document.addEventListener(ev, function (e) { clearTimeout(t); t = setTimeout(function () { refresh(e); }, 250); });
    });
  }

  function boot() { document.querySelectorAll('[data-uups]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
